import { render, staticRenderFns } from "./MarketTypeEdit.vue?vue&type=template&id=62b83824"
import script from "./MarketTypeEdit.vue?vue&type=script&lang=js"
export * from "./MarketTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports